import { render, staticRenderFns } from "./ProductVariantSettings.vue?vue&type=template&id=299c41e7"
import script from "./ProductVariantSettings.vue?vue&type=script&lang=js"
export * from "./ProductVariantSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports